import type { LpTokensBalanceGroup } from '@/components/dashboard/useGroupedBalances/useGroupedPositions'

export const lpTokensBalanceMock: LpTokensBalanceGroup = [
  {
    groupName: 'USD',
    balances: [
      {
        address: '0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB',
        vaultId: '0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB',
        network: {
          name: 'base',
          chainId: 8453,
          networkCaip: 'eip155:8453',
        },
        asset: {
          address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
          assetCaip: 'eip155:8453/erc20:0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
          assetGroup: 'USD',
          name: 'USD Coin',
          symbol: 'USDC',
          decimals: 6,
          assetLogo: 'https://images.vaults.fyi/tokens/usdc.png',
          balanceNative: '2500000000',
          balanceUsd: '2500',
          unclaimedNative: '0',
          unclaimedUsd: '0',
          positionValueInAsset: '2500000',
        },
        name: 'Aave v3 USDC',
        protocol: {
          protocolId: 'aave-collateral-vault-v3',
          name: 'aave',
          product: 'collateral vault',
          version: 'v3',
          description:
            'Lenders earn yield from interest paid by borrowers. Borrowers deposit collateral into Aave and borrow overcollateralized loans from liquidity pools. The interest paid by borrowers is distributed to lenders who have supplied assets to the liquidity pool.',
        },
        apy: {
          base: 0.05,
          reward: 0,
          total: 0.05,
        },
        apyComposite: undefined,
        balanceUsd: 2500,
        balanceNative: '2500000000',
        childrenVaults: [],
      },
      {
        address: '0xb125E6687d4313864e53df431d5425969c15Eb2F',
        vaultId: '0xb125E6687d4313864e53df431d5425969c15Eb2F',
        network: {
          name: 'base',
          chainId: 8453,
          networkCaip: 'eip155:8453',
        },
        asset: {
          address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
          assetCaip: 'eip155:8453/erc20:0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
          assetGroup: 'USD',
          name: 'USD Coin',
          symbol: 'USDC',
          decimals: 6,
          assetLogo: 'https://images.vaults.fyi/tokens/usdc.png',
          balanceNative: '3000000000',
          balanceUsd: '3000',
          unclaimedNative: '0',
          unclaimedUsd: '0',
          positionValueInAsset: '3000000',
        },
        name: 'Compound v3 USDC',
        protocol: {
          protocolId: 'compound-compound-finance-v3',
          name: 'compound',
          product: 'compound finance',
          version: 'v3',
          description:
            'Lenders earn yield from interest paid by borrowers. Borrowers deposit collateral into the Compound v3 protocol, and then borrow overcollateralized loans from a pool of lenders. The interest paid by borrowers is distributed to lenders.',
        },
        apy: {
          base: 0.05,
          reward: 0,
          total: 0.05,
        },
        apyComposite: undefined,
        balanceUsd: 3000,
        balanceNative: '3000000000',
        childrenVaults: [],
      },
    ],
    groupTotalBalance: 5500,
    groupApy: 0.05,
  },
  {
    groupName: 'ETH',
    balances: [
      {
        address: '0x46e6b214b524310239732D51387075E0e70970bf',
        vaultId: '0x46e6b214b524310239732D51387075E0e70970bf',
        network: {
          name: 'base',
          chainId: 8453,
          networkCaip: 'eip155:8453',
        },
        asset: {
          address: '0x4200000000000000000000000000000000000006',
          assetCaip: 'eip155:8453/erc20:0x4200000000000000000000000000000000000006',
          assetGroup: 'ETH',
          name: 'Wrapped Ether',
          symbol: 'WETH',
          decimals: 18,
          assetLogo: 'https://images.vaults.fyi/tokens/weth.png',
          balanceNative: '0',
          balanceUsd: '0',
          unclaimedNative: '0',
          unclaimedUsd: '0',
          positionValueInAsset: '2000000000000000000',
        },
        name: 'Compound v3 WETH',
        protocol: {
          protocolId: 'compound-compound-finance-v3',
          name: 'compound',
          product: 'compound finance',
          version: 'v3',
          description:
            'Lenders earn yield from interest paid by borrowers. Borrowers deposit collateral into the Compound v3 protocol, and then borrow overcollateralized loans from a pool of lenders. The interest paid by borrowers is distributed to lenders.',
        },
        apy: {
          base: 0.04,
          reward: 0.015,
          total: 0.04,
        },
        apyComposite: undefined,
        balanceUsd: 6000,
        balanceNative: '2000000000000000000',
        childrenVaults: [],
      },
      {
        address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
        vaultId: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
        network: {
          name: 'mainnet',
          chainId: 1,
          networkCaip: 'eip155:1',
        },
        asset: {
          address: '0x0000000000000000000000000000000000000000',
          assetCaip: 'eip155:1/slip44:60',
          assetGroup: 'ETH',
          name: 'Ether',
          symbol: 'ETH',
          decimals: 18,
          assetLogo: 'https://images.vaults.fyi/tokens/eth.png',
          balanceNative: '0',
          balanceUsd: '0',
          unclaimedNative: '0',
          unclaimedUsd: '0',
          positionValueInAsset: '1000000000000000000',
        },
        name: 'Lido stETH',
        protocol: {
          protocolId: 'lido',
          name: 'lido',
          product: '',
          version: '',
        },
        apy: {
          base: 0.03,
          reward: 0,
          total: 0.03,
        },
        apyComposite: undefined,
        balanceUsd: 3000,
        childrenVaults: [],
        balanceNative: '1000000000000000000',
      },
    ],
    groupTotalBalance: 9000,
    groupApy: 0.035,
  },
]
